import { coerceDate } from "./time";

function isAbsentDeadline(value) {
  return value === null || value === undefined || value === "";
}

function resolveNowMillis(now = Date.now()) {
  if (now instanceof Date) return now.getTime();
  if (typeof now?.toMillis === "function") return now.toMillis();
  return Number(now);
}

export function resolveBasicPollDeadlineValue(poll = {}) {
  const nested = poll?.settings?.deadlineAt;
  return !isAbsentDeadline(nested) ? nested : poll?.deadlineAt ?? null;
}

export function resolveBasicPollDeadline(poll = {}) {
  return coerceDate(resolveBasicPollDeadlineValue(poll));
}

export function resolveSchedulerVotingDeadlineValue(scheduler = {}) {
  return scheduler?.votingDeadlineAt ?? null;
}

export function resolveSchedulerVotingDeadline(scheduler = {}) {
  return coerceDate(resolveSchedulerVotingDeadlineValue(scheduler));
}

export function hasSchedulerVotingDeadline(scheduler = {}) {
  const value = resolveSchedulerVotingDeadlineValue(scheduler);
  return value !== null && value !== undefined && value !== "";
}

export function isDeadlineOpen(value, now = Date.now()) {
  if (isAbsentDeadline(value)) return true;
  const deadline = coerceDate(value);
  const nowMillis = resolveNowMillis(now);
  if (!deadline || !Number.isFinite(nowMillis)) return false;
  return deadline.getTime() > nowMillis;
}

export function isBasicPollDeadlineOpen(poll = {}, now = Date.now()) {
  return isDeadlineOpen(resolveBasicPollDeadlineValue(poll), now);
}

export function isBasicPollVotingOpen(poll = {}, now = Date.now()) {
  return (
    String(poll?.status || "OPEN").trim().toUpperCase() === "OPEN" &&
    isBasicPollDeadlineOpen(poll, now)
  );
}

export function isSchedulerVotingOpen(scheduler = {}, now = Date.now()) {
  return (
    String(scheduler?.status || "OPEN").trim().toUpperCase() === "OPEN" &&
    isDeadlineOpen(scheduler?.votingDeadlineAt ?? null, now)
  );
}
